import React from 'react'
import PropTypes from 'prop-types'
import { isMobile } from 'react-device-detect'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import { injectIntl } from 'react-intl'
import styled from 'styled-components'
import { Row, Col } from 'core/components/ui'
import SVG from 'core/components/svg'
import svg from 'assets/svg'
import _ from 'lodash'
import { font, greys } from 'assets/themes/theme-default'
import img from 'assets/images'
import { configuratorShape } from '../../shapes'

const MOBILE_SIZE = 40

const RenderColor = styled(Row)`
  border: 1px solid ${greys.light4};
  background-image: url(${props => props.reference && img.textures});
  background-color: #${props => props.color.value};
  background-position-y: -${props => 80 * (props.reference - 1)}px;
  background-position-x: -${props => (props.typeselected ? 145 * (props.typeselected - 1) : 0)}px;
  width: ${isMobile ? `${MOBILE_SIZE}px` : '100%'};
  height: ${isMobile ? `${MOBILE_SIZE}px` : '80px'};
  border-radius: ${isMobile && '40px'};
  margin-bottom: 10px;
  cursor: pointer;
  position: relative;
`
const RenderColorLabel = styled.p`
  color: ${greys.dark3};
  font-weight: ${font.weight.base};
  font-size: ${font.size.xs};
  line-height: ${isMobile && 'normal'};
  text-align: center;
  word-wrap: break-word;
`
const CheckedIcon = styled(SVG)`
  width: ${isMobile ? `${MOBILE_SIZE / 2}px` : '30px'};
  fill: ${props => props.theme.colors.color1.bg};
  z-index: 3;
  position: absolute;
  top: 50%;
  right: 50%;
  margin: ${isMobile ? `-${MOBILE_SIZE / 4}px -${MOBILE_SIZE / 4}px 0 0` : '-15px -15px 0 0'};
  border: 2px solid ${greys.light4};
  border-radius: 20px;
`

const referencialColors = [
  {
    // white
    value: 'ffffff',
    id: 1
  },
  {
    // grey
    value: '848482',
    id: 2
  },
  {
    // black
    value: '000000',
    id: 3
  },
  {
    // blue
    value: '007cad',
    id: 4
  },
  {
    // yellow
    value: 'f4c800',
    id: 6
  },
  {
    // red
    value: 'c10020',
    id: 5
  },
  {
    // green
    value: '007d34',
    id: 7
  },
  {
    // beige
    value: 'e2d6b0',
    id: 8
  },
  {
    // bordeau
    value: '621c4d',
    id: 9
  },
  {
    // Brown
    value: '753313',
    id: 10
  },
  {
    // Orange
    value: 'ff6800',
    id: 11
  },
  {
    // Pink
    value: 'ff7e93',
    id: 12
  },
  {
    // Purple
    value: '943391',
    id: 13
  }
]

const Design = props => {
  const { configurator, setConfigurator, item } = props

  const { design } = configurator

  const handleOnChangeSelectionColor = () => {
    setConfigurator({
      ...configurator,
      design: {
        ...configurator.design,
        exterior: { ...configurator.design.exterior, color: item }
      }
    })
  }

  const renderListColors = () => {
    const colorSelected = design.exterior.color

    const typeSelected = design.exterior.type ? design.exterior.type.type : null

    const filteredReferencialColors = _.first(
      referencialColors.filter(itemReference => itemReference.value === item.value)
    )
    const referencialId = filteredReferencialColors ? filteredReferencialColors.id : null

    return (
      <Col
        span={isMobile ? 6 : 6}
        onClick={handleOnChangeSelectionColor}
        data-test="component-configurator-design-colorWrapper"
      >
        <RenderColor
          color={item}
          typeselected={typeSelected}
          reference={referencialId}
          type="flex"
          align="middle"
          justify="center"
          data-test="configurator-design-color-renderColor"
        >
          <TransitionGroup>
            {colorSelected && colorSelected.label === item.label && (
              <CSSTransition
                key="checkedColor"
                classNames="fade"
                timeout={{ enter: 2200, exit: 200 }}
              >
                <CheckedIcon svg={svg.checked} data-test="configurator-design-color-CheckedIcon" />
              </CSSTransition>
            )}
          </TransitionGroup>
        </RenderColor>
        <RenderColorLabel>{item.label}</RenderColorLabel>
      </Col>
    )
  }

  return renderListColors()
}

Design.propTypes = {
  item: PropTypes.shape().isRequired,
  setConfigurator: PropTypes.func.isRequired,
  configurator: configuratorShape.isRequired
}

export default injectIntl(Design)
